export default {
  'ticket.operator': 'оператор',
  'ticket.status': 'статус',
  'ticket.lastupdate': 'Последнее обновление',
  'ticket.ticketid': 'Билет ID',
  'ticket.subject': 'субъект',
  'ticket.total': 'Все билеты',
  'ticket.notassigned': 'Hе назначено',
  'ticket.addnewticket': 'Новый билет',
  'ticket.search': 'Поиск',
  'ticket.myticket': 'Мой билет',
  'ticket.knowleadgebase': 'База знаний',
  'ticket.announcements': 'Объявления',
  'ticket.description': 'Описание',
  'ticket.mytickets': 'Мои билеты',
  'ticket.knowledgebase': 'База знаний',
  'ticket.announcements': 'Объявлении',
  'ticket.all': 'Все',
  'ticket.done': 'Выполнено',
  'ticket.inprogress': 'Обрабатывается',
  'ticket.new': 'новый',
  'ticket.ticketsInbox': 'входящие',
  'ticket.ticketsUnread': 'Непрочитано(2)',
  'ticket.ticketid': 'Билет ID',
  'ticket.sender': 'отправитель',
  'ticket.findtickets': 'Поиск билетов',
  'ticket.newticket': 'Новый билет',
  'ticket.text': 'Текст',
  'ticket.insertSubject': 'Пожалуйста, введите тему вашего запроса',
  'ticket.insertText': 'Пожалуйста, введите текст вашего запроса',
  'ticket.insertMessageAndSubject':
    'Пожалуйста, введите тему и текст вашего запроса',
  'ticket.details': 'Подробности',
  'ticket.reply': 'Ответ',
  'ticket.dateoforder': 'Дата заказа',
  'ticket.dateoftravel': 'Дата поездки',
  'ticket.item': 'вещь',
  'ticket.submitinwriting': 'Отправить в письменном виде',
  'ticket.send': 'Отправить',
  'ticket.attachphoto':
    'В этой части раздела заявки вы можете загрузить желаемое фото по ссылке ниже .',
};
